import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { style: {"text-align":"left","margin-left":"25%"} }, " 睡眠时长 ", -1)),
    _createElementVNode("div", {
      class: "chart",
      ref: $setup.setRef
    }, null, 512)
  ], 64))
}